import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSelector } from "reselect";
import VisibleFor from "../../auth/components/VisibleFor";
import { Role } from "../../auth/types";
import { Favorite } from "../../common/components/Favorite";
import { IApplicationState } from "../../redux/root-reducer";
import { INode } from "../../search/types";
import { getNodeInfoAfterRefreshingPage } from "../nodeDetails.actions";
import styles from "./ChosenNode.module.scss";
export interface INodeProps {
  chosenNode: INode | undefined;
}

const getDomainSelector = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => ({
    domainCode: commonState.selectedDomain?.Code ?? "",
    userIsReady: commonState.userIsReady,
  })
);

const ChosenNode = ({ chosenNode }: INodeProps) => {
  const { domainCode, userIsReady } = useSelector(getDomainSelector);
  const { id }: any = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (domainCode) {
      if (
        (userIsReady && chosenNode?.ID !== -1) ||
        (userIsReady && parseInt(id) !== chosenNode?.ID)
      ) {
        dispatch(getNodeInfoAfterRefreshingPage(domainCode, id));
      }
    }
  }, [id, userIsReady]);

  const { t } = useTranslation();
  return (
    <div className={styles.currentNodeContainer}>
      <VisibleFor
        roles={[Role.Landlord]}
        child={
          <>
            <p className={styles.apartment}>
              {t("APT")} {chosenNode?.Name}
            </p>
            <div className={styles.headerDiv}>
              <div className={styles.favoriteStyle}>
                {chosenNode?.ID !== -1 ? (
                  <div className={styles.favDiv}>
                    <Favorite selectedNode={chosenNode!} />
                    <p className={styles.save}>{t("Save")}</p>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        }
      ></VisibleFor>
    </div>
  );
};

export default ChosenNode;
